import { render, staticRenderFns } from "./StockKLine5Day.vue?vue&type=template&id=5fc8c4fe&scoped=true"
import script from "./StockKLine5Day.vue?vue&type=script&lang=js"
export * from "./StockKLine5Day.vue?vue&type=script&lang=js"
import style0 from "./StockKLine5Day.vue?vue&type=style&index=0&id=5fc8c4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8c4fe",
  null
  
)

export default component.exports